import z from 'zod'

export const hasMinLength = (password: string): boolean => {
  return password.length >= 8
}
export const hasCombination = (password: string): boolean => {
  return /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d]).*$/.test(password)
}

export const cleanEmptyValues = (object: any): any =>
  Object.fromEntries(
    Object.entries(object).filter(([, value]) => value !== '' && value !== null)
  )

const urlSchema = z
  .url()
  .refine(value => value.startsWith('http://') || value.startsWith('https://'))

export const isUrl = (value: unknown): boolean =>
  urlSchema.safeParse(value).success

/**
 * Returns true when a value should be considered "empty" and
 * excluded from display (undefined, null, empty string, or
 * empty non-array object).
 */
export const isEmptyValue = (value: unknown): boolean => {
  if (value === undefined || value === null || value === '') return true
  if (
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.keys(value as Record<string, unknown>).length === 0
  )
    return true
  return false
}
